// Module
var code = "<branch-regions></branch-regions>\n";
// Exports
module.exports = code;